import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-32 min-h-[70vh] flex flex-col justify-center">
      <div className="eyebrow mb-3 text-stone-500">CHECKOUT CANCELLED</div>
      <h1 data-testid="payment-cancel" className="font-display text-4xl md:text-6xl leading-[0.9] mb-4">NO CHARGE.</h1>
      <p className="font-serif text-xl text-stone-300 max-w-lg mb-8">
        You backed out before paying — no worries, nothing was charged. The free plan still gives you 5 audits a month.
      </p>
      <div className="flex flex-wrap gap-3">
        <Link to="/pro" data-testid="cancel-back-pricing" className="inline-flex items-center gap-2 font-label text-xs tracking-widest bg-[#EF3340] text-white px-6 py-4 hover:bg-[#cc2a35] transition-colors">
          SEE PLANS AGAIN <ArrowRight className="w-3 h-3" />
        </Link>
        <Link to="/find" className="inline-flex items-center gap-2 font-label text-xs tracking-widest border hairline px-6 py-4 hover:border-[#EF3340]">
          KEEP AUDITING FREE
        </Link>
      </div>
    </div>
  );
}
